import CustomError from '../components/CustomError/CustomError';
import { isEmpty } from '../utils/utils';

export function handleGraphQLError({ error, enqueueSnackbar, onFinally }) {
  if (!error || isEmpty(error)) return;

  if (error.graphQLErrors?.length > 0) {
    const featureDisabledErrors = error.graphQLErrors.filter(err => err.extensions?.code === 'FEATURE_DISABLED');

    const otherErrors = error.graphQLErrors.filter(err => err.extensions?.code !== 'FEATURE_DISABLED');

    // One warning for FEATURE_DISABLED
    if (featureDisabledErrors.length > 0) {
      enqueueSnackbar(<CustomError message={featureDisabledErrors[0].message} />, {
        variant: 'warning',
        autoHideDuration: 5000
      });
    }

    // Individual errors for the rest
    otherErrors.forEach(gqlError => {
      enqueueSnackbar(<CustomError message={gqlError.message} />, {
        variant: 'error',
        autoHideDuration: null
      });
    });
  } else {
    // Fallback non-GraphQL error
    enqueueSnackbar(<CustomError message={error.message} />, {
      variant: 'error',
      autoHideDuration: null
    });
  }

  onFinally?.();
}
